import React from 'react';

import Button from '@atlaskit/button/standard-button';
import DropdownMenu, {
  DropdownItem,
  DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import Tooltip from '@atlaskit/tooltip';

import { DropdownProps } from './Dropdown';
import {
  DropdownOptionIconStyled,
  DropdownOptionLabelStyled,
  DropdownOptionStyled,
} from './Dropdown.styled';

export interface DropdownViewProps extends DropdownProps {}

export const DropdownView: React.FC<DropdownViewProps> = ({
  currentValue,
  options,
  isDisabled,
  onChange,
  position = 'left-start',
}: DropdownViewProps) => {
  return (
    <DropdownMenu
      shouldFlip={false}
      placement={position}
      trigger={({ triggerRef, ...props }) => (
        <Button
          {...props}
          iconBefore={currentValue.icon}
          iconAfter={
            <HipchatChevronDownIcon
              label='Open'
              size='small'
              primaryColor='var(--ds-icon, var(--ds-fb-icon))'
            />
          }
          ref={triggerRef}
          appearance='default'
        />
      )}
      testId='Dropdown'
    >
      <DropdownItemGroup>
        {options.map((option) => {
          return (
            <Tooltip key={option.value} content={option.tooltip}>
              <DropdownItem
                isDisabled={isDisabled || option.isDisabled}
                onClick={onChange.bind(null, option)}
              >
                <DropdownOptionStyled
                  data-testid={`dropdown-option-${option.label}`}
                >
                  <DropdownOptionIconStyled>
                    {option.icon || ''}
                  </DropdownOptionIconStyled>
                  <DropdownOptionLabelStyled>
                    {option.label}
                  </DropdownOptionLabelStyled>
                </DropdownOptionStyled>
              </DropdownItem>
            </Tooltip>
          );
        })}
      </DropdownItemGroup>
    </DropdownMenu>
  );
};
